/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_HintInputs */

const cs_integrations_gbp_hint = /** @type {(inputs: Integrations_Gbp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte firemní profil Google a publikujte lokální příspěvky.`)
};

const en_integrations_gbp_hint = /** @type {(inputs: Integrations_Gbp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect the office GBP location to publish local posts.`)
};

/**
* | output |
* | --- |
* | "Connect the office GBP location to publish local posts." |
*
* @param {Integrations_Gbp_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_hint = /** @type {((inputs?: Integrations_Gbp_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_hint(inputs)
	return cs_integrations_gbp_hint(inputs)
});